import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [isLead, setIsLead] = React.useState<boolean>(false);

  useEffect(() => {
    // Get the 'lead' query parameter from the URL
    const queryParams = new URLSearchParams(window.location.search);
    const leadParam = queryParams.get("lead");

    // Set isLead to true if the lead parameter is 'true'
    if (leadParam === "true") {
      localStorage.setItem("lead", "true");
      setIsLead(true);
    }
  }, []);

  if (isAuthenticated) {
    // Check if the user has completed the survey
    // const hasCompletedSurvey =
    //   localStorage.getItem("surveyCompleted") === "true";

    // // If they haven't completed the survey, redirect to the survey page
    // if (!hasCompletedSurvey) {
    //   return <Navigate to="/survey" replace />;
    // }

    // Otherwise, redirect to the dashboard
    return <Navigate to="/dashboard" replace />;
  }

  const handleGoogleSignIn = () => {
    window.location.href = `${import.meta.env.VITE_API_URL}/api/auth/google`;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-zinc-50">
      <div className="flex flex-col items-center max-w-sm w-full px-6">
        <img src="/logo.svg" alt="Logo" className="w-20 h-20 mb-8" />
        <h1 className="text-3xl font-semibold mb-2 text-gray-900">
          Welcome to UGZ.ai
        </h1>
        <p className="text-gray-600 mb-8 mt-2 text-center">
          Login to start generating UGC videos
        </p>

        <button
          onClick={handleGoogleSignIn}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-200 rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors shadow-sm hover:cursor-pointer"
        >
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google logo"
            className="w-5 h-5"
          />
          <span>Continue with Google</span>
        </button>

        <p className="mt-8 text-sm text-gray-500 text-center">
          By continuing, you agree to our{" "}
          <a
            href="https://ugz.ai/terms"
            className="text-blue-600 hover:underline"
          >
            Terms of use
          </a>{" "}
          &{" "}
          <a
            href="https://ugz.ai/privacy"
            className="text-blue-600 hover:underline"
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
